// videoCallUserUidは1or2で始まる9桁の数なので、元のuidの先頭に9をつけることで簡易的に可逆的なuidを生成する

import { UID } from 'agora-rtc-react'

const VIDEO_CALL_USER_UID_LENGTH = 9

/** 画面共有用のユーザーUIDから元のuserUidを復元する */
export const extractOriginalUserUidFromScreenShareUserUid = (
  screenShareUserUid: UID,
): number => {
  if (typeof screenShareUserUid !== 'number') {
    throw new Error('画面共有用のユーザーUIDは数値である必要があります。')
  }
  // decode
  const screenShareUserUidStr = screenShareUserUid.toString()
  const isValidStart = screenShareUserUidStr.endsWith('0')
  const isValidLength =
    screenShareUserUidStr.length === VIDEO_CALL_USER_UID_LENGTH + 1
  const isValidNumber = !isNaN(screenShareUserUid) && screenShareUserUid >= 0

  if (!isValidStart || !isValidLength || !isValidNumber) {
    throw new Error(
      '画面共有用のユーザーUIDではありません。正しい形式である必要があります。',
    )
  }
  // 最初の9桁を返す
  return parseInt(
    screenShareUserUidStr.slice(0, VIDEO_CALL_USER_UID_LENGTH),
    10,
  )
}

/** 画面共有用のユーザーUIDかどうかを判定する */
export const isScreenShareUserUid = (userUid: UID): boolean => {
  if (typeof userUid !== 'number') {
    throw new Error('ユーザーUIDは数値である必要があります。')
  }
  const userUidStr = userUid.toString()
  return (
    userUidStr.endsWith('0') &&
    userUidStr.length === VIDEO_CALL_USER_UID_LENGTH + 1
  )
}
